<template>
  <div class="row-card-title left">
    <div @click="setTabTittleColor('user')">
      <div :class="getTabTittleColor(dynamicStyle.user)">User</div>
      <template v-if="dynamicStyle.user">
        <div class="line" />
      </template>
    </div>
    <div @click="setTabTittleColor('enrolled')">
      <div :class="getTabTittleColor(dynamicStyle.enrolled)">Enrolled</div>
      <template v-if="dynamicStyle.enrolled">
        <div class="line" />
      </template>
    </div>
    <div @click="setTabTittleColor('completed')">
      <div :class="getTabTittleColor(dynamicStyle.completed)">Complete</div>
      <template v-if="dynamicStyle.completed">
        <div class="line" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "userOverviewTitleTab",
  data() {
    return {
      dynamicStyle: { user: true, enrolled: false, completed: false }
    };
  },
  methods: {
    getTabTittleColor(status) {
      switch (status) {
        case true:
          return "card-title-active";
        case false:
          return "card-title";
      }
    },
    setTabTittleColor(state) {
      switch (state) {
        case "user":
          this.dynamicStyle = { user: true, enrolled: false, completed: false };
          break;
        case "enrolled":
          this.dynamicStyle = { user: false, enrolled: true, completed: false };
          break;
        case "completed":
          this.dynamicStyle = { user: false, enrolled: false, completed: true };
          break;
      }
    }
  }
};
</script>
